import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';

@Injectable({
  providedIn: 'root',
})
export class RouteLogSummariesService extends BitfApiService {
  constructor(protected injector: Injector) {
    super('route-log-summaries', injector);
  }
}
